import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Card, CardBody, Col, Container, Input, Label, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'

const columns = [
    { label: 'Fecha',        field: 'fecha',           sort: 'asc' },
    { label: 'Usuario',      field: 'username',        sort: 'asc' },
    { label: 'Operación',    field: 'tipo_badge',      sort: 'asc' },
    { label: 'Registros',    field: 'total_registros', sort: 'asc' },
    { label: 'Detalle',      field: 'detalle',         sort: 'asc' },
];

export default class HistorialImportacionArticulo extends React.Component {

    constructor(props) {
        super(props)
        this.apiRest = new ApiRest(props);
        this.state = {
            tabla: { columns, rows: [] },
            cargando: false,
            filtro: {
                fecha_inicio: '',
                fecha_fin: '',
                tipo_operacion: '',
            },
        }
    }

    componentDidMount() {
        this.buscar();
    }

    onChange = ({ target: { name, value } }) => {
        this.setState(prev => ({ filtro: { ...prev.filtro, [name]: value } }));
    }

    buscar = () => {
        this.setState({ cargando: true });
        const { filtro } = this.state;
        const params = new URLSearchParams();
        if (filtro.fecha_inicio)   params.append('fecha_inicio',   filtro.fecha_inicio);
        if (filtro.fecha_fin)      params.append('fecha_fin',      filtro.fecha_fin);
        if (filtro.tipo_operacion) params.append('tipo_operacion', filtro.tipo_operacion);

        const auth = this.apiRest.getLS('authUser');
        if (!auth) { this.props.history.push('/Timeout'); return; }

        fetch(`${process.env.REACT_APP_API_URL}/historialImportacionArticulo?${params}`, {
            headers: { 'Authorization': 'Bearer ' + auth.access }
        })
        .then(r => r.json())
        .then(data => {
            if (!Array.isArray(data)) throw new Error();
            const rows = data.map(r => ({
                ...r,
                tipo_badge: (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                        padding: '3px 10px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '700',
                        background: r.tipo_operacion === 'creacion' ? '#ede9fe' : '#fef3c7',
                        color:      r.tipo_operacion === 'creacion' ? '#6d28d9'  : '#b45309',
                        border:     r.tipo_operacion === 'creacion' ? '1px solid #c4b5fd' : '1px solid #fcd34d',
                    }}>
                        <i className={r.tipo_operacion === 'creacion' ? 'fas fa-layer-group' : 'fas fa-pen-square'} />
                        {r.tipo_label}
                    </span>
                ),
            }));
            this.setState({ tabla: { columns, rows }, cargando: false });
        })
        .catch(() => {
            toastr.error('Error al cargar el historial.');
            this.setState({ cargando: false });
        });
    }

    limpiar = () => {
        this.setState({ filtro: { fecha_inicio: '', fecha_fin: '', tipo_operacion: '' } }, this.buscar);
    }

    render() {
        const { filtro, cargando } = this.state;

        return (
            <React.Fragment>
                <style>{`
                    .tabla-hist .dataTables_wrapper thead th {
                        background-color: #1e293b !important; color: #fff !important;
                        font-weight: 600; padding: 11px 14px !important;
                    }
                    .tabla-hist .dataTables_wrapper thead th::after,
                    .tabla-hist .dataTables_wrapper thead th::before { color: rgba(255,255,255,0.5) !important; }
                    .tabla-hist .dataTables_wrapper tbody td { padding: 10px 14px !important; vertical-align: middle !important; }
                    .tabla-hist .dataTables_wrapper tbody tr:hover td { background-color: #f8fafc !important; }
                    .btn-hist { color: #fff !important; border: none; border-radius: 6px; font-weight: 600; }
                    .btn-hist:hover { filter: brightness(0.88); color: #fff !important; }
                `}</style>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Artículos" breadcrumbItem="Historial de Importación Masiva" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col lg={3}>
                                                <Label className="form-label">Fecha inicio</Label>
                                                <Input type="date" name="fecha_inicio" value={filtro.fecha_inicio} onChange={this.onChange} className="form-control" />
                                            </Col>
                                            <Col lg={3}>
                                                <Label className="form-label">Fecha fin</Label>
                                                <Input type="date" name="fecha_fin" value={filtro.fecha_fin} onChange={this.onChange} className="form-control" />
                                            </Col>
                                            <Col lg={3}>
                                                <Label className="form-label">Tipo de operación</Label>
                                                <select name="tipo_operacion" value={filtro.tipo_operacion} onChange={this.onChange} className="form-control">
                                                    <option value="">Todas</option>
                                                    <option value="actualizacion">Actualización masiva</option>
                                                    <option value="creacion">Creación masiva</option>
                                                </select>
                                            </Col>
                                            <Col lg={3} style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                                                <MDBBtn className="waves-effect btn-hist" style={{ background: '#1d4ed8' }} onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}Buscar
                                                </MDBBtn>
                                                <MDBBtn className="waves-effect btn-hist" style={{ background: '#6b7280' }} onClick={this.limpiar}>
                                                    <MDBIcon icon="fas fa-times" />{' '}Limpiar
                                                </MDBBtn>
                                            </Col>
                                        </Row>

                                        {cargando && (
                                            <Row className="mb-3">
                                                <Col style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Spinner color="primary" />
                                                </Col>
                                            </Row>
                                        )}

                                        <div className="table-responsive tabla-hist">
                                            <MDBDataTable
                                                striped hover
                                                searchLabel="Buscar.."
                                                paginationLabel={["Anterior", "Siguiente"]}
                                                noRecordsFoundLabel="No hay registros."
                                                infoLabel={["Mostrando desde ", "hasta", " | Total: ", ""]}
                                                entriesLabel="Entradas"
                                                data={this.state.tabla}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
